import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Routes from "routing/Routes";
import NumberUtils from "util/NumberUtils";
import { MetricsMapper, MetricContainer, CounterRate } from "components/metrics";
const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
const Title = styled.div`
  color: ${({ theme }) => theme.colors.link.default};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.link.hover};
    text-decoration: underline;
  }
`;
const TitleCol = ({ cache, children }) => {
  const navigate = useNavigate();
  const onClick = useCallback(() => {
    navigate(Routes.SYSTEM.LOOKUPTABLES.CACHES.show(cache.name));
  }, [navigate, cache.name]);
  return /* @__PURE__ */ React.createElement(TitleRow, null, /* @__PURE__ */ React.createElement(Title, { onClick }, children));
};
const EntriesCol = ({ cache }) => {
  const entriesMap = {
    count: `org.graylog2.lookup.caches.${cache.id}.entries`
  };
  const computeEntriesMetrics = (metrics) => {
    const total = Object.keys(metrics).reduce(
      (acc, nodeId) => acc + (Number.isNaN(metrics[nodeId].count.metric.value) ? 0 : metrics[nodeId].count.metric.value),
      0
    );
    if (total < 1) return "N/A";
    return NumberUtils.formatNumber(total);
  };
  return /* @__PURE__ */ React.createElement(MetricsMapper, { map: entriesMap, computeValue: computeEntriesMetrics });
};
const HitRateCol = ({ cache }) => {
  const countMap = {
    requests: `org.graylog2.lookup.caches.${cache.id}.requests`,
    hits: `org.graylog2.lookup.caches.${cache.id}.hits`,
    misses: `org.graylog2.lookup.caches.${cache.id}.misses`
  };
  const computeCountMetrics = (metrics) => {
    const totalHits = Object.keys(metrics).reduce((acc, nodeId) => {
      var _a, _b, _c, _d;
      const total2 = (_d = (_c = (_b = (_a = metrics[nodeId]) == null ? void 0 : _a.hits) == null ? void 0 : _b.metric) == null ? void 0 : _c.rate) == null ? void 0 : _d.total;
      return acc + (Number.isFinite(total2) ? total2 : 0);
    }, 0);
    const totalMisses = Object.keys(metrics).reduce((acc, nodeId) => {
      var _a, _b, _c, _d;
      const total2 = (_d = (_c = (_b = (_a = metrics[nodeId]) == null ? void 0 : _a.misses) == null ? void 0 : _b.metric) == null ? void 0 : _c.rate) == null ? void 0 : _d.total;
      return acc + (Number.isFinite(total2) ? total2 : 0);
    }, 0);
    const total = totalHits + totalMisses;
    if (total < 1) return "N/A";
    const hitRate = totalHits * 100 / total;
    return `${NumberUtils.formatNumber(hitRate)}%`;
  };
  return /* @__PURE__ */ React.createElement(MetricsMapper, { map: countMap, computeValue: computeCountMetrics });
};
const ThroughputCol = ({ cache }) => /* @__PURE__ */ React.createElement(MetricContainer, { name: `org.graylog2.lookup.caches.${cache.id}.requests` }, /* @__PURE__ */ React.createElement(CounterRate, { suffix: "lookups/s" }));
const columnRenderers = {
  attributes: {
    title: {
      width: 0.2,
      renderCell: (title, cache) => /* @__PURE__ */ React.createElement(TitleCol, { cache }, title)
    },
    description: {
      width: 0.2,
      renderCell: (description) => /* @__PURE__ */ React.createElement("span", null, description)
    },
    name: {
      width: 0.2,
      renderCell: (name) => /* @__PURE__ */ React.createElement("span", null, name)
    },
    entries: {
      staticWidth: "matchHeader",
      renderCell: (_arg, cache) => /* @__PURE__ */ React.createElement(EntriesCol, { cache })
    },
    hit_rate: {
      staticWidth: "matchHeader",
      renderCell: (_arg, cache) => /* @__PURE__ */ React.createElement(HitRateCol, { cache })
    },
    throughput: {
      staticWidth: 150,
      renderCell: (_arg, cache) => /* @__PURE__ */ React.createElement(ThroughputCol, { cache })
    }
  }
};
export default columnRenderers;
